import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { transformResponseHandler } from 'utils/transformResponseHandler';

export const collectionPointsApi = createApi({
    reducerPath: 'collectionPointsApi',
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_API_ROUTE}/pos`,
        prepareHeaders: (headers, { getState }) => {
            const token = getState()?.posData?.token;
            if (token) {
                headers.set('Authorization', token);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getCollectionPoints: builder.query({
            query: () => ({
                url: `/collection-points?perPage=all`, // update URL as per your API endpoint
                method: 'GET',
            }),
            // Uncomment and update as needed:
            // transformResponse: (resp) => transformResponseHandler(resp),
            providesTags: ['CollectionPoints'],
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        addCollectionPoints: builder.mutation({
            query: (body) => ({
                url:'/collection-points',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['CollectionPoints'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        updateCollectionPoints: builder.mutation({
            query: ({id, ...body}) => ({
                url:`/collection-points/${id}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['CollectionPoints'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        deleteCollectionPoints: builder.mutation({
            query: (id) => ({
                url: `/collection-points/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['CollectionPoints'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        changeStatusCollectionPoints:builder.mutation({
            query: ({id, body}) => ({
                url:`/collection-points/change-status/${id}`,
                method: 'PUT',
                body: {status: body},
            }),
            invalidatesTags: ['CollectionPoints'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
    }),
});

export const { 
    useAddCollectionPointsMutation,
    useUpdateCollectionPointsMutation,
    useGetCollectionPointsQuery,
    useDeleteCollectionPointsMutation,
    useChangeStatusCollectionPointsMutation
 } = collectionPointsApi;
